import { render, staticRenderFns } from "./subhot.vue?vue&type=template&id=63efda05&scoped=true&"
import script from "./subhot.vue?vue&type=script&lang=js&"
export * from "./subhot.vue?vue&type=script&lang=js&"
import style0 from "./subhot.vue?vue&type=style&index=0&id=63efda05&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63efda05",
  null
  
)

export default component.exports